import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const SHOOT_STATUS = {
  PLANNED: { label: "Planlandı", cls: "bg-sky-500/10 text-sky-700 border-sky-500/30" },
  SHOT: { label: "Çekildi – bilgi bekliyor", cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
  COMPLETED: { label: "Portföye aktarıldı", cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
};

export const DRONE_STATUS = {
  PENDING_APPROVAL: { label: "Onay bekliyor", cls: "bg-sky-500/10 text-sky-700 border-sky-500/30" },
  DATE_REJECTED: { label: "Tarih reddedildi", cls: "bg-red-500/10 text-red-700 border-red-500/30" },
  AWAITING_PAYMENT: { label: "Ödeme bekleniyor", cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
  RECEIPT_UPLOADED: { label: "Dekont inceleniyor", cls: "bg-violet-500/10 text-violet-700 border-violet-500/30" },
  APPROVED: { label: "Kesinleşti", cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  COMPLETED: { label: "Tamamlandı", cls: "bg-slate-500/10 text-slate-700 border-slate-500/30" },
  CANCELLED: { label: "İptal edildi", cls: "bg-rose-500/10 text-rose-700 border-rose-500/30" },
};

export const SLOT_LABEL = { MORNING: "Sabah 09:00-12:00", AFTERNOON: "Öğleden sonra 13:00-17:00" };

export const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const openReceipt = async (url) => {
  const win = window.open("", "_blank");
  try {
    const { data } = await api.get(url, { responseType: "blob" });
    win.location.href = URL.createObjectURL(data);
  } catch (err) {
    win?.close();
    toast.error(formatApiError(err.response?.data?.detail) || "Dekont açılamadı");
  }
};
